import { render, staticRenderFns } from "./TheDocumentHistory.vue?vue&type=template&id=bc594162&scoped=true&"
import script from "./TheDocumentHistory.vue?vue&type=script&lang=js&"
export * from "./TheDocumentHistory.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentHistory.vue?vue&type=style&index=0&id=bc594162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc594162",
  null
  
)

export default component.exports